export function encodeBase64(str) {
    return btoa(str)
}

export function decodeBase64(str) {
    return atob(str)
}

export function decodeJwtObject(jwt) {
    let base64 = jwt.split('.')[1]
    return JSON.parse(decodeBase64(base64))
}



// WEBPACK FOOTER //
// ./src/common/base64.js